//noinspection JSUnusedGlobalSymbols

/**
 * @copyright {{PKG_COPYRIGHT}}
 * @license  {{PKG_LICENSE}}
 */

/**
 * ESA Component: View
 * -------------------------------------------------------------
 * @copyright (c) 2024 [Paul Höcker|PHMG](https://phmg.online). All rights reserved.
 * @license   GNU General Public License version 3 or later
 * @version   1.0.0, 2024-01-01 00:00
 */

class View {
	component = 'esa'
	initiated = false
	controllers = []
	active = []
	_names = []
	utils

	/**
	 * View Constructor
	 * @param {[]} controllers
	 * @param {Utils} [utils]
	 */
	constructor(controllers, utils) {
		this.controllers = controllers || [];
		this.utils = utils || window.Hive.getUtils();

		const J = this.utils.getJoomla(true);
		const context = Object.assign(
			{ view : '', layout : '', id : 0, controllers : [] },
			J.getOptions(`${this.component}.context`, {})
		);
		const requested = context['controllers'] !== undefined ? context['controllers'] : [];
		for (let controller of this.controllers) {
			if (requested.includes(controller.CID)) {
				this.activate(controller, context);
			}
		}
	}

	/**
	 *
	 * @param controller
	 * @param context
	 */
	activate(controller, context) {
		let name = `${controller.NAME} (${controller.CID})`;
		try {
			this.active.push(new controller(context));
			this.utils.odb(`Activating controller ${name}.`, this);
			this._names.push(name);
		} catch (exception) {
			this.utils.error(exception.message || `Error activating controller ${name}.`, exception);
		}
	}

	/**
	 *
	 * @param event
	 */
	onLoad(event) {
		if (this.initiated) return;

		for (let i = 0; i < this.active.length; i++) {
			let name = this._names[i];
			try {
				this.active[i].initiate(event);
				this.utils.odb(`Initiating controller ${name}.`, this);
			} catch (exception) {
				this.utils.error(exception.message || `Error initiating controller ${name}.`, exception);
			}
		}

		this.initiated = true;
	}

	/**
	 *
	 * @param event
	 */
	onUpdate(event) {
		this.utils.odb(event);

		for (let i = 0; i < this.active.length; i++) {
			let name = this._names[i];
			try {
				this.active[i].update(event);
			} catch (exception) {
				this.utils.error(exception.message || `Error updating controller ${name}.`, exception);
			}
		}
	}
}

export {View}